'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.repositorySystem', [])

.factory('repositorySystemService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/API/Repository/System';

    service.validateSystemWhenIsAutomated = function (systemId) {
        return $http.post(baseUrl + '/' + systemId + '/ValidateWhenIsAutomated')
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
